import { columns } from "../fable_modules/Fulma.3.0.0/Layouts/Columns.fs.js";
import { ofArray, map, singleton, empty } from "../fable_modules/fable-library-js.4.25.0/List.js";
import { Option, ISize, column } from "../fable_modules/Fulma.3.0.0/Layouts/Column.fs.js";
import { content, Header_title, header, card } from "../fable_modules/Fulma.3.0.0/Components/Card.fs.js";
import { String_fromOption } from "../fable_modules/Webbler.Models.1.3.1/Extensions.fs.js";
import * as react from "react";
import { singleton as singleton_1, append, delay, toList } from "../fable_modules/fable-library-js.4.25.0/Seq.js";
import { keyValueList } from "../fable_modules/fable-library-js.4.25.0/MapUtil.js";
import { practiceInfo, generateSectionView } from "../Package/PackageView.js";
import { Screen } from "../fable_modules/Fulma.3.0.0/Common.fs.js";
import { container } from "../fable_modules/Fulma.3.0.0/Layouts/Container.fs.js";
import { equals } from "../fable_modules/fable-library-js.4.25.0/Util.js";
import { PatientPackageViewModel_get_empty } from "../ThreeDocs.Models/View/PatientPackageViewModel.js";

export function detailView(patientPackageVm) {
    let children;
    const package$ = patientPackageVm.packageViewModel;
    const children_6 = [columns(empty(), ofArray([column(empty(), singleton(card(empty(), ofArray([header(empty(), singleton(Header_title(empty(), singleton((children = [String_fromOption(package$.title)], react.createElement("h1", {}, ...children)))))), content(empty(), toList(delay(() => {
        let props_2, children_2;
        return append(singleton_1((props_2 = [["style", {
            whiteSpace: "pre-wrap",
        }]], (children_2 = [`Dear ${patientPackageVm.invitationViewModel.patientName},
`, String_fromOption(package$.intro)], react.createElement("p", keyValueList(props_2, 1), ...children_2)))), delay(() => append(map((section) => generateSectionView(patientPackageVm.mediaViewModels, section), package$.sections), delay(() => {
            let props_4, children_4;
            return singleton_1((props_4 = [["style", {
                whiteSpace: "pre-wrap",
            }]], (children_4 = [String_fromOption(package$.outro)], react.createElement("p", keyValueList(props_4, 1), ...children_4))));
        }))));
    })))])))), column(singleton(new Option(0, [new Screen(0, []), new ISize(7, [])])), singleton(practiceInfo(patientPackageVm.practiceViewModel)))]))];
    return react.createElement("div", {}, ...children_6);
}

export function view(model, _dispatch) {
    return container(empty(), toList(delay(() => {
        let children_2, children_6, s_2;
        const matchValue = model.patientPackageVm;
        let matchResult, vm_1, vm_2, e;
        if (matchValue.tag === 1) {
            if (matchValue.fields[0].tag === 6) {
                if (matchValue.fields[0].fields[0].tag === 4) {
                    matchResult = 2;
                }
                else {
                    matchResult = 3;
                    e = matchValue.fields[0];
                }
            }
            else {
                matchResult = 3;
                e = matchValue.fields[0];
            }
        }
        else if (equals(matchValue.fields[0], PatientPackageViewModel_get_empty())) {
            matchResult = 0;
            vm_1 = matchValue.fields[0];
        }
        else {
            matchResult = 1;
            vm_2 = matchValue.fields[0];
        }
        switch (matchResult) {
            case 0:
                return singleton_1((children_2 = [react.createElement("div", {
                    className: "spinner is-loading",
                }, "Please wait")], react.createElement("div", {}, ...children_2)));
            case 1:
                return singleton_1(detailView(vm_2));
            case 2:
                return singleton_1(react.createElement("div", {}, "This Invitation has expired. Please contact your clinic if you need a new invitation."));
            default:
                return singleton_1((children_6 = [(s_2 = "Something went wrong. We are unable to retrieve your procedure package at this time. Please try again later. If this issue persists please contact your clinic or 3DOCS for assistance.", s_2)], react.createElement("div", {}, ...children_6)));
        }
    })));
}

